import { render, staticRenderFns } from "./ScannerComponent.vue?vue&type=template&id=2a29f873&scoped=true&"
import script from "./ScannerComponent.vue?vue&type=script&lang=js&"
export * from "./ScannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScannerComponent.vue?vue&type=style&index=0&id=2a29f873&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29f873",
  null
  
)

export default component.exports